<template>
  <div id="swagger-container"></div>
</template>

<script>
import SwaggerUI from 'swagger-ui';

export default {
  mounted() {
    let doc = 'partner';

    console.log(this.$route);

    if (this.$route.name !== 'partner api docs') {
      doc = 'api';
    }

    SwaggerUI({
      url: `https://api.colorful.co/docs/${doc}.json`,
      dom_id: '#swagger-container',
      deepLinking: false,
      presets: [SwaggerUI.presets.apis],
    });
  },
};
</script>

<style lang="scss">
  @import "../styles/swagger.css";
</style>
